export const ipVersionMap = {
  ipv4: "IPv4",
  ipv6: "IPv6",
};

export const reversedIpVersionMap = Object.entries(ipVersionMap).reduce((map, [key, value]) => {
  map[value] = key;
  return map;
}, {});
